Shopify.theme.jsProduct = {
  init: function () {
    this.videoTab();
    this.giftMessege();
  },
  videoTab: function () {
    let videoButton = document.querySelector('.js-video-button-tab');
    let videoTabs = document.querySelectorAll('.js-video-tab');
    let videoAccordion = document.querySelector('.layout-accordion .description__block_video.init_slider');
    if (videoButton && videoTabs) {
      if (screen.width < 1024 && videoAccordion) {
        const config = {
          attributes: true,
          childList: true,
          subtree: true
        };
        const callback = function (mutationsList, observer) {
          if (document.querySelector('.layout-accordion .description__block_video.init_slider .video-layout--slider.slider-loaded')) {
            videoAccordion.classList.remove('init_slider');
            videoAccordion.removeAttribute('open');
            observer.disconnect();
          }
        };
        const observer = new MutationObserver(callback);
        observer.observe(videoAccordion, config);
      }
      videoButton.addEventListener('click', function () {
        videoTabs.forEach(tab => {
          tab.click();
          tab.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        });
      });
    }
  },
  giftMessege: function () {
    let giftMessageWrapper = document.querySelector('.gift-message-wrapper');
    let giftMessagePopup = document.querySelector('.gift-message-popup');
    let giftMessageType = document.querySelectorAll('.gift-type');
    let giftMessagePopupClose = document.querySelectorAll('[data-message-popup-close]');
    let giftMessageAddress = document.getElementById('gift_message_address');
    let giftMessageEircode = document.getElementById('gift_message_eircode');
    let giftMessageEmail = document.getElementById('gift_message_email');
    let giftMessageAddressWrapper = document.querySelector('.gift-message-fields-address');
    let giftMessageEircodeWrapper = document.querySelector('.gift-message-fields-eircode');
    let giftMessageEmailWrapper = document.querySelector('.gift-message-fields-email');
    let giftMessagePopupTitle = document.querySelector('.gift-message-popup-title');
    let addToCartBtn = document.getElementById('add_to_cart');
    if (!giftMessageWrapper) return false;
    giftMessageType.forEach(giftType => {
      giftType.addEventListener('click', e => {
        let selectedTypeRadio = document.querySelector('[name="properties[_gift_message_type]"]:checked');
        let selectedType = '';
        if (selectedTypeRadio) {
          selectedType = selectedTypeRadio.value;
          if (addToCartBtn) {
            addToCartBtn.removeAttribute('disabled');
          }
          if (selectedType.toLowerCase().includes('email')) {
            giftMessagePopupTitle.textContent = selectedType;
            giftMessageAddress.value = '';
            giftMessageAddressWrapper.classList.add('hidden');
            giftMessageEircode.value = '';
            giftMessageEircodeWrapper.classList.add('hidden');
            giftMessageEmailWrapper.classList.remove('hidden');
          } else {
            giftMessagePopupTitle.textContent = selectedType;
            giftMessageEmail.value = '';
            giftMessageEmailWrapper.classList.add('hidden');
            giftMessageAddressWrapper.classList.remove('hidden');
            giftMessageEircodeWrapper.classList.remove('hidden');
          }
          giftMessagePopup.classList.remove('hidden');
        }
      });
    });
    giftMessagePopupClose.forEach(closeBtn => {
      closeBtn.addEventListener('click', e => {
        giftMessagePopup.classList.add('hidden');
      });
    });
  }
};
Shopify.theme.jsProduct.init();
